const FeedbackLoader = require('client/feedbackLoader');
const t = require('engine/i18n/t');
const LANG = require('config').lang;

t.i18n.add('courses', require('../../locales/' + LANG + '.yml'));

function init() {
  const loader = new FeedbackLoader(window.FEEDBACK_LIST_INIT);
  const statList = document.querySelector('.feedback-stat__list');

  statList.addEventListener('click', (e) => {
    const titleElem = e.target.closest('[data-stars]');
    if (!titleElem) return;

    const stars = titleElem.getAttribute('data-stars');
    const teacher = loader.selects.teacher.value;
    loader.applyFilter({ stars, teacher });
  });

  loader.elem.addEventListener('feedbackChange', () => {
    const activeStarsElem = statList.querySelector('[data-stars].feedback-stat__item_active');
    if (activeStarsElem) {
      activeStarsElem.classList.remove('feedback-stat__item_active');
    }
    if (loader.filter.stars) {
      statList.querySelector(`[data-stars="${loader.filter.stars}"]`).classList.add('feedback-stat__item_active');
    }
  });
}


module.exports = init;

if (window.FEEDBACK_LIST_INIT) {
  init();
}
